import Navigation from "./Navigation";
import Footer from "./Footer";
import Contact from "./Contact";
import { usePageMeta } from "./page-meta";

export const ContactPage = ({ scrollTo }) => {
  usePageMeta(
    "Connect with DUNC — Contact Us",
    "The fastest way to reach DUNC is WhatsApp. First Sip, retail & distribution, partnerships, or just to say hi."
  );

  return (
    <>
      <Navigation scrollTo={scrollTo} />
      <main className="relative min-h-screen overflow-hidden" data-testid="contact-page">
        <div className="pt-24">
          <Contact />
        </div>
        <Footer scrollTo={scrollTo} />
      </main>
    </>
  );
};

export default ContactPage;
